import { clearActiveIndex } from "./assementSlice";

const clearAllSlicesThunk = (dispatch) => {
  dispatch(clearActiveIndex());
};

export default clearAllSlicesThunk;
